import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditTaskType = ({TTId, list}) => {
    const [taskTypeData, setTaskTypeData] = useState(null);

    const fetchTaskType = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/tasktype/${Id}`)
            .then(response => {
                setTaskTypeData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setTaskTypeData([]); 
            });
    }

    useEffect(() => {
        if (TTId) {
            fetchTaskType(TTId);
        }
    },[TTId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        title: Yup.string().required(),
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (taskTypeData) {
            reset(taskTypeData);
        }
    }, [taskTypeData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/tasktype/${TTId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_tasktype_${TTId}`);
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
            });
    }

    if (!TTId || !taskTypeData) {
        return null;
    }

    return (
        <div id={`edit_tasktype_${TTId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Task Type</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-block mb-3">
                                <label className="col-form-label">Task Type Title <span className="text-danger">*</span></label>
                                <input className="form-control" type="text" defaultValue={taskTypeData.title} {...register('title')}/>
                                <div className="text-sm text-danger">
                                    {errors.title && <p>{errors.title.message}</p>}
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditTaskType